import { TZDateMini } from '@date-fns/tz';

import { formatDate } from '@dynatrace-sdk/units';
import { getTimezone } from '@dynatrace-sdk/user-preferences';

import { useCalendarContext } from '../hooks/useCalendarContext.js';

/**
 * SelectMonthLabel component
 * Renders the formatted label for the select month view
 */
export const SelectMonthLabel = () => {
  const { state } = useCalendarContext();
  return (
    <>
      {formatDate(new TZDateMini(state.activeDate, getTimezone()), {
        year: 'numeric',
      })}
    </>
  );
};
SelectMonthLabel['displayName'] = 'SelectMonthLabel';
